import axios from "axios"
import * as env from "../constants/env"


/* Studios Of The Admin */
export const studios = () => {
    const uri = `${env.startpoint}pitboard/studios`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Launch — a one time link into PitBoard */
export const launch = (data) => {
    const uri = `${env.startpoint}pitboard/launch`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}
